import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MyEdiaryApiService } from './my-ediary-api.service';
import { MyEdiaryStoreEffects } from './my-ediary-store.effects';
import {
  myEdiaryInitialState,
  myEdiaryReducer
} from './my-ediary-store.reducer';

@NgModule({
  imports: [
    StoreModule.forFeature('myEdiary', myEdiaryReducer, {
      initialState: myEdiaryInitialState
    }),
    EffectsModule.forFeature([MyEdiaryStoreEffects])
  ],
  providers: [MyEdiaryApiService]
})
export class MyEdiaryStoreModule {}
